<template>
  <div
    class="
      rounded-lg
      bg-white
      px-5
      py-5
      my-5
      md:my-0 md:px-10
      shadow-sm
      mx-auto
      max-w-95
      lg:max-w-screen-md
    "
  >
    <p class="text-sm text-center text-brand-dark-gray">
      {{ currentStep }} of 3
    </p>
    <h2 class="text-xlg font-semibold py-5 text-center">
      Verify your identity with Experian
    </h2>
    <div class="flex flex-row justify-center pb-3">
      <div class="flex items-center">
        <LockClosedIcon class="text-brand-blue w-6 h-6 mr-1" />
        <p class="text-brand-blue">Secure</p>
      </div>
    </div>
    <router-view />
  </div>
</template>
<script>
import { LockClosedIcon } from "@heroicons/vue/outline"

export default {
  components: {
    LockClosedIcon
  },
  computed: {
    currentStep() {
      switch (this.$route.name) {
        case "dashboard_verify_disclaimer":
          return 1
        case "dashboard_verify_personal_info":
          return 2
        case "dashboard_verify_questions":
          return 3
        default:
          return 1
      }
    }
  },
  data() {
    return {}
  },
  mounted() {
    if (this.$route.name === "dashboard_verify") {
      this.$router.push({ name: "dashboard_verify_disclaimer" })
    }
  }
}
</script>
